var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 19",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6.023C.716.023 0 .74 0 1.623v13.8c0 .884.716 1.6 1.6 1.6h.623a2.633 2.633 0 0 0 2.542 1.954 2.633 2.633 0 0 0 2.54-1.954h2.711c.582 0 1.054-.472 1.054-1.054V1.077L10.016.023H1.6Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49.022c-.002 2.333-.002 4.666-.002 7L7.297 5.783a.474.474 0 0 0-.708.413v5.353c0 .363.392.59.708.412l2.191-1.239v6.301h5.994c.838 0 1.518-.68 1.518-1.518V1.535A1.518 1.518 0 0 0 15.482.024H9.489Z",
    fill: "#C8D1DB"
  })));
};
export default __webpack_public_path__ + "static/media/blockly.581c545e.svg";
export { SvgComponent as ReactComponent };